import { useMemo } from "react";
import { getLocalSearchHistory } from "./search-local-history";
import { matchesSearchTerm, uniqueTerms } from "./search-term-match";

export const useSearchTerms = ({
  search,
  searchInFocus,
  mobileOverlayOpen,
  searchHistory,
  searchRelatedTerms,
  trendingPostTerms,
  frequentSearches,
  trimmedSearch,
}) => {
  const localSearchHistory = useMemo(() => getLocalSearchHistory(), [
    mobileOverlayOpen,
    searchInFocus,
    search,
  ]);

  const recentTerms = useMemo(
    () =>
      uniqueTerms([
        ...localSearchHistory,
        ...searchHistory.map((item) => item?.searchTerm),
      ]),
    [localSearchHistory, searchHistory]
  );

  const matchedRecentTerms = useMemo(
    () =>
      recentTerms
        .filter((term) => matchesSearchTerm(term, trimmedSearch))
        .slice(0, 4),
    [recentTerms, trimmedSearch]
  );

  const suggestionTerms = useMemo(
    () =>
      uniqueTerms([
        ...searchRelatedTerms,
        ...trendingPostTerms,
        ...frequentSearches.map((item) => item?.searchTerm),
      ])
        .filter((term) => matchesSearchTerm(term, trimmedSearch))
        .filter(
          (term) =>
            !matchedRecentTerms.some(
              (recent) => recent.toLowerCase() === term.toLowerCase()
            )
        )
        .slice(0, 5),
    [
      searchRelatedTerms,
      trendingPostTerms,
      frequentSearches,
      matchedRecentTerms,
      trimmedSearch,
    ]
  );

  return {
    matchedRecentTerms,
    suggestionTerms,
  };
};
